module.exports = __webpack_public_path__ + "img/1f429.c115b05.svg";